'use client'

import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from '@/core/api/baseQuery'

import { GenericResponseOData } from '@/core/api/interfaces/GenericResponseOData'
import { MenuReserva } from '@/core/odata/interfaces/MtPerseveranceBackendApiRepositoriesModel'

export const menuReservasApi = createApi({
  reducerPath: 'menuReservasApi',
  baseQuery,
  endpoints: (builder) => ({
    getMenuReservas: builder.query<GenericResponseOData<MenuReserva[]>, void>({
      query: () => ({
        url: `/MenuReservas?$select=MenuReservaId,Nombre&$filter=Eliminado eq false`,
        method: 'GET',
      }),
    }),
    getMenuReservasId: builder.query<
      MenuReserva,
      { id: number }
    >({
      query: ({ id }) => ({
        url: `/MenuReservas(${id})?$select=MenuReservaId,Nombre`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useGetMenuReservasQuery,
  useLazyGetMenuReservasIdQuery
} = menuReservasApi
